import builder from '../builder';
import AccountingDocument from '../../streamline-icons/bold/accounting-document.svg';

export default builder('IconAccountingDocumentBold', AccountingDocument);
